import { Instagram } from "lucide-react";

export const Footer = () => (
  <footer className="mt-20 border-t border-stone-200 bg-stone-900 text-stone-300">
    <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-3">
          <img src="/kedai-logo.png" alt="Kedai Impor" className="w-11 h-11 object-contain bg-white rounded-lg p-0.5" />
          <span className="font-display font-extrabold text-xl text-white">Kedai <span className="text-emerald-400">Impor</span></span>
        </div>
        <p className="text-sm text-stone-400 max-w-md leading-relaxed">
          Jembatan belanja grosir langsung dari ribuan supplier di China ke Indonesia. Cari pakai
          Bahasa Indonesia, bayar Rupiah, ambil di kedai terdekat. Kami bantu kirim sampai gudang
          & sampai ke tanganmu.
        </p>
        <a
          href="https://instagram.com/kedaiimporofficial"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="mt-4 inline-flex items-center gap-2 bg-stone-800 hover:bg-stone-700 text-stone-200 text-sm font-semibold px-4 py-2 rounded-full transition-colors"
        >
          <Instagram size={17} className="text-pink-400" />
          @kedaiimporofficial
        </a>
      </div>
      <div>
        <h4 className="font-display font-semibold text-white mb-3 text-sm">Layanan</h4>
        <ul className="space-y-2 text-sm text-stone-400">
          <li>Belanja Grosir Import</li>
          <li>Jasa Kirim China-Indo</li>
          <li>Jaringan Kedai Lokal</li>
          <li>Edukasi Belanja Import</li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-semibold text-white mb-3 text-sm">Kenapa Kami</h4>
        <ul className="space-y-2 text-sm text-stone-400">
          <li>Kurs Bersaing</li>
          <li>Garansi Barang Sampai</li>
          <li>Pendampingan Kedai</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-stone-800 py-4 text-center text-xs text-stone-500 flex flex-col sm:flex-row items-center justify-center gap-2">
      <span>© 2026 Kedai Impor — Bantu warga daerah belanja grosir dari China dengan mudah.</span>
      <a href="https://instagram.com/kedaiimporofficial" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-stone-400 hover:text-pink-400 transition-colors"><Instagram size={14} />@kedaiimporofficial</a>
    </div>
  </footer>
);
